<style scoped lang="scss">
  .market{
    border:1px solid #E4E6EA;
    padding:40px 50px 30px;
    margin-top: 50px;
    .info{
      padding:80px 0;
      p{
        margin:50px 0;
      }
    }
  }
  @media screen and (max-width: 640px){
    .container{
      width: 90% !important;
      font-size: 12px!important;
    }
    .el-col-12{
      width: 90% !important;
    }
    .success h2{
      font-size: 20px!important;
    }
    .success{
      padding-top: 20px!important;
    }
    section{
      padding-top: 20px!important;
    }
    .market{
      font-size: 14px!important;
      padding: 20px!important;
    }
    .market .info{
      padding: 0px!important;
    }
    .img-box img{
      margin-top: 10px;
      width: 250%;
    }
  }
</style>
<template>
  <div class="wrap wrap-sanger">
    <section class="container">
      <div class="success">
        <img src="@/assets/images/icon_success.png">
        <h2 v-if="type === 'geneConsult'">咨询提交成功</h2>
        <h2 v-else>订单提交成功</h2>
        前往个人中心查看 <router-link :to="orderLink.to">{{orderLink.name}}</router-link>
      </div>
      <div class="market">
        <el-carousel indicator-position="outside" height="380px">
          <el-carousel-item v-for="item in marketLists" :key="item.id">
            <el-row :gutter="90">
              <el-col :span="12">
                <div class="info">
                  <div class="fz20 text-primary fb">{{item.name}}</div>
                  <p>{{item.content}}</p>
                  <el-button type="primary" size="mini" @click="toCarouselLink(item)" v-show="item.clickTriggerAction !== 'NONE'">了解更多</el-button>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="img-box tr">
                  <img :src="item.img.visitedUrl">
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>
  </div>
</template>

<script>
import { marketCarousels } from '@/services/api.index'
export default {
  data () {
    return {
      marketLists: [],
      orderLink: {},
      type: this.$route.query.type
    }
  },
  created() {
    this._init()
    this.getMarkets()
  },
  methods: {
    _init () {
      let { orderLink, type } = this
      switch (type) {
        case 'molecular':
          orderLink = {name: '擎科科邦邦商城订单', to: '/user/molecular'}
          break
        case 'sanger':
          orderLink = {name: '取样信息记录', to: '/user/sanger_record'}
          break
        case 'primer':
          orderLink = {name: '引物合成订单', to: '/user/primer'}
          break
        case 'gene':
        case 'geneConsult':
          orderLink = {name: '基因合成订单', to: '/user/gene'}
          break
        case 'integral':
          orderLink = {name: '积分兑换订单', to: '/user/integral_exchange'}
          break
      }
      this.orderLink = orderLink
    },
    getMarkets () {
      marketCarousels().then(res => {
        this.marketLists = res.data
      })
    },
    toCarouselLink (item) {
      this.baseMethods.carouselsAction(item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/success_submit.vue